(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[350],{

/***/ 980350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(629815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_DesignSystem_NavigationItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(153987);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(540190);
/* harmony import */ var _SubscriberInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(156695);
/* harmony import */ var _components_LogoutModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(821448);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(186812);
/* harmony import */ var _utils_commonToggleAuthModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13605);
/* harmony import */ var _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(385126);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(336623);
/* harmony import */ var _components_FooterMap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(176364);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(913886);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(849784);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(792516);
/* harmony import */ var _FooterStorePolicies__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(781059);
/* harmony import */ var _hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(482516);
/* harmony import */ var _footerUtils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(362371);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(326706);
/* harmony import */ var _hooks_useStoreLogoOrNameVisibility__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(273323);
/* harmony import */ var _utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(168491);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(299375);























var Footer = function(props) {
    var toggleAuthModal = function toggleAuthModal() {
        var ref;
        if ((0,_utils_commonToggleAuthModal__WEBPACK_IMPORTED_MODULE_9__/* .commonToggleAuthModal */ .D)({
            userLogin: user === null || user === void 0 ? void 0 : user.isLogin,
            storeInfoDomain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain
        })) toggleLogoutModal();
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderLoginLogout = function renderLoginLogout() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_8__/* .deviceWidth */ .o > _utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .MAX_MOBILE_WIDTH */ .Cf ? showLoginForDesktop() : showLoginForMobile()
        });
    };
    var showLoginForMobile = function showLoginForMobile() {
        if (headerName === "Header14" && !isLoginVisible) {
            return null;
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    marginLeft: 33,
                    marginTop: -16
                },
                onClick: toggleAuthModal,
                className: "cfeNavItems__item fw6",
                children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
            });
        }
    };
    var showLoginForDesktop = function showLoginForDesktop() {
        if (headerName === "Header14" && !isLoginVisible) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            style: {
                marginLeft: 0
            },
            onClick: toggleAuthModal,
            className: "cfeNavItems__item fw6",
            children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
        });
    };
    var authAndLogoutModal = function authAndLogoutModal() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: showLogoutConfirmation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LogoutModal__WEBPACK_IMPORTED_MODULE_7__["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: _utils_excuteLogout__WEBPACK_IMPORTED_MODULE_10__/* .executeLogout */ .q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        });
    };
    var getCurrentYear = function getCurrentYear() {
        return new Date().getFullYear() || "";
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21;
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            user: state.userReducer
        };
    }).user;
    var ref22 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_17__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            storePolicies: state.storePolicyReducer.data,
            navigationList: state.additionalPagesReducer.navigationList,
            catalogCategories: state.catalogReducer.categories,
            productTags: state.catalogReducer.productTags
        };
    }), storeData = ref22.storeData, navigationList = ref22.navigationList, storePolicies = ref22.storePolicies, catalogCategories = ref22.catalogCategories, productTags = ref22.productTags;
    var ref23 = (0,_hooks_useStoreLogoOrNameVisibility__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(), isStoreLogoInFooter = ref23.isStoreLogoInFooter, isStoreNameInFooter = ref23.isStoreNameInFooter;
    var storeLogo = (0,_utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(storeData);
    var ref24 = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(), storeAddress = ref24.storeAddress, storePhone = ref24.storePhone, storeEmail = ref24.storeEmail;
    var ref25 = (0,_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_15__/* .useFeatureLocks */ .r)(), leadGenFeatureStatus = ref25.leadGenFeatureStatus, visitorLoginFeatureStatus = ref25.visitorLoginFeatureStatus;
    var isLeadGenVisible = leadGenFeatureStatus === null || leadGenFeatureStatus === void 0 ? void 0 : leadGenFeatureStatus.isVisible;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref26 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showLogoutConfirmation = ref26[0], setShowLogoutConfirmation = ref26[1];
    var headerName = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name;
    var isLoginVisible = props === null || props === void 0 ? void 0 : (ref4 = props.config) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hidden_components) === null || ref5 === void 0 ? void 0 : ref5.login_view;
    var dsLabel = (0,_footerUtils__WEBPACK_IMPORTED_MODULE_16__/* .getFooterDSLabel */ .m)({
        configs: storeData === null || storeData === void 0 ? void 0 : storeData.configs,
        suffix: "APP",
        customStyles: {
            textTransform: "uppercase"
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length)) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_21__/* .getStorePolicies */ .S)({
                store_id: storeData.store_id
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_22__/* .getNavigationPagesList */ .A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    var renderSocialMediaProfileDetails = function() {
        var ref, ref1, ref2;
        if (!((ref = storeData.social_media_profile_details) === null || ref === void 0 ? void 0 : ref.media_count) || ((ref1 = storeData.social_media_profile_details) === null || ref1 === void 0 ? void 0 : ref1.media_count) < 1) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "footer-social-media-container",
            style: {
                width: "246px",
                marginBottom: "1rem"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: "Follow us here"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "social-media-section flex space-between",
                    children: (ref2 = storeData.social_media_profile_details) === null || ref2 === void 0 ? void 0 : ref2.media_detail.map(function(profile) {
                        return profile.profile_url !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "social-media-icon",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: profile.profile_url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: profile.image_url,
                                    alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image")
                                })
                            })
                        }, profile.id) : null;
                    })
                })
            ]
        });
    };
    var renderEmailAndPhoneNumber = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                !!storeEmail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "store-information__subsection",
                    style: {
                        marginTop: 40
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                alt: "mail",
                                src: "https://cdn.dotpe.in/kiranaStatic/icons/mail.png"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "mailto:".concat(storeEmail),
                            children: storeEmail
                        })
                    ]
                }),
                !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "store-information__subsection",
                    style: {
                        marginTop: storeEmail ? 10 : 40
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                alt: "phone",
                                src: "https://cdn.dotpe.in/kiranaStatic/icons/ringingtelephone.png"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "tel:".concat(storePhone),
                            children: storePhone
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            authAndLogoutModal(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
                className: "Footer2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "Footer2__top-section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between center Footer2__top-section--inner",
                            style: {
                                maxWidth: (storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.address) === null || ref6 === void 0 ? void 0 : ref6.visibility) === 2 ? "1000px" : "100%",
                                padding: (storeData === null || storeData === void 0 ? void 0 : (ref7 = storeData.address) === null || ref7 === void 0 ? void 0 : ref7.visibility) === 2 ? "0 2rem" : "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "Footer2__section footer-shop-desc",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "top-section",
                                            children: [
                                                storeLogo && isStoreLogoInFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: storeLogo,
                                                    height: "67",
                                                    width: "67",
                                                    alt: "store logo"
                                                }),
                                                isStoreNameInFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: storeData === null || storeData === void 0 ? void 0 : (ref8 = storeData.store_info) === null || ref8 === void 0 ? void 0 : ref8.name
                                                })
                                            ]
                                        }),
                                        isLeadGenVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "bottom-section",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SubscriberInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                                        }) : null,
                                        ((storeData === null || storeData === void 0 ? void 0 : (ref9 = storeData.store_info) === null || ref9 === void 0 ? void 0 : ref9.description) || (storeData === null || storeData === void 0 ? void 0 : (ref10 = storeData.store_info) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.description) === null || ref11 === void 0 ? void 0 : ref11.length) > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "bottom-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    children: "About Us"
                                                }),
                                                (storeData === null || storeData === void 0 ? void 0 : (ref12 = storeData.store_info) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.description) === null || ref13 === void 0 ? void 0 : ref13.length) > 160 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "desc-text",
                                                    children: [
                                                        storeData === null || storeData === void 0 ? void 0 : (ref14 = storeData.store_info) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.description) === null || ref15 === void 0 ? void 0 : ref15.substr(0, 160),
                                                        "..."
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "desc-text",
                                                    children: storeData === null || storeData === void 0 ? void 0 : (ref16 = storeData.store_info) === null || ref16 === void 0 ? void 0 : ref16.description
                                                })
                                            ]
                                        }),
                                        (storeData === null || storeData === void 0 ? void 0 : (ref17 = storeData.store_info) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.description) === null || ref18 === void 0 ? void 0 : ref18.length) > 160 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "desc-text__view-more fw6 pointer underline-hover",
                                            onClick: function() {
                                                var ref;
                                                next_router__WEBPACK_IMPORTED_MODULE_4___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_5__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.ABOUT_US, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                            },
                                            children: "View More"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "Footer2__section flex-column",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DesignSystem_NavigationItems__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            categories: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(productTags).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(catalogCategories)) || [],
                                            horizontalNav: false,
                                            navigationItems: navigationList || [],
                                            isFooter: true,
                                            headerName: headerName
                                        }),
                                        isVisitorLoginVisible && renderLoginLogout(),
                                        renderEmailAndPhoneNumber()
                                    ]
                                }),
                                storeAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "Footer2__section store-information",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: "Visit Us"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "address-text",
                                                children: storeAddress
                                            })
                                        ]
                                    })
                                }),
                                (storeData === null || storeData === void 0 ? void 0 : storeData.social_media_profile_details) && renderSocialMediaProfileDetails(),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FooterMap__WEBPACK_IMPORTED_MODULE_12__/* .FooterMap2 */ .oJ, {
                                    storeData: storeData
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FooterStorePolicies__WEBPACK_IMPORTED_MODULE_14__/* .FooterStorePolicies */ .p, {
                        storePolicies: storePolicies,
                        path: _utils_routes__WEBPACK_IMPORTED_MODULE_5__.PATH.STORE_POLICIES
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "Footer2__bottom-section",
                        children: [
                            !(props === null || props === void 0 ? void 0 : (ref19 = props.config) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.hidden_components) === null || ref20 === void 0 ? void 0 : ref20.payment_method_images_not_visible) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    display: "none"
                                },
                                className: "flex items-center mr2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "payment-text mr3-ns mb0-ns mb3",
                                        children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("pay_after_cta")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/TVi0GjBB.webp",
                                                className: "mr3",
                                                height: "14"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/Jbc2OXoQ.webp",
                                                className: "mr3",
                                                height: "17"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/PyQ0f6jJ.webp",
                                                className: "mr3",
                                                height: "26"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/Z4KF5xF9.webp",
                                                height: "22"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center footer__bottom-text",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Copyright ",
                                        getCurrentYear(),
                                        dsLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                ". ",
                                                dsLabel
                                            ]
                                        }) : "",
                                        " | ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: _utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .CANCELATION_AND_REFUND_POLICY_URL */ .a6,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Refunds & Cancellation"
                                        }),
                                        " | ",
                                        (storeData === null || storeData === void 0 ? void 0 : (ref21 = storeData.services) === null || ref21 === void 0 ? void 0 : ref21.delivery_time_approx) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: _utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .DS_TERMS_AND_CONDITIONS_URL */ .gl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Terms & Conditions"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: _utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .DS_TERMS_AND_CONDITIONS_URL */ .gl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Terms & Conditions"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 781059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ FooterStorePolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186438);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27909);




var FooterStorePolicies = function(props) {
    return !props.storePolicies || props.storePolicies.length == 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottom_section), " flex flex-column items-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().store_policies), " flex justify-around w-100 f6"),
            children: props === null || props === void 0 ? void 0 : props.storePolicies.map(function(page) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    name: "page".concat(page.page_type),
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_nav),
                    onClick: function() {
                        return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__/* .handleRouteChangesOnClick */ .Z)(props === null || props === void 0 ? void 0 : props.path, {
                            page_type: page.page_type
                        });
                    },
                    children: page.page_name
                }, page.id);
            })
        })
    });
};


/***/ }),

/***/ 362371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getFooterDSLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(693967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var getFooterDSLabel = function(param) {
    var configs = param.configs, _prefix = param.prefix, prefix = _prefix === void 0 ? "" : _prefix, _suffix = param.suffix, suffix = _suffix === void 0 ? "" : _suffix, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? {} : _customStyles;
    var ref;
    var showDsLabel = !!((ref = configs === null || configs === void 0 ? void 0 : configs.ds_branding_flag) !== null && ref !== void 0 ? ref : 1);
    if (showDsLabel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                prefix ? "".concat(prefix, " powered") : "Powered",
                " by \xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "https://download.digitalshowroom.app/download-cfe",
                    target: "_blank",
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("underline copyright-text-grey-color tw-cursor-pointer", customClasses),
                    rel: "website app link noreferrer",
                    style: customStyles,
                    children: [
                        "Digital Showroom ",
                        suffix
                    ]
                })
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 156695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DesignSystem_SubscriberInput; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/redux/actions/leadgen.js
var leadgen = __webpack_require__(900171);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/assets/svgExports/ForwardArrow.js

var ForwardArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16.031",
        height: "16.031",
        viewBox: "0 0 16.031 16.031",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Path_49",
            "data-name": "Path 49",
            d: "M-3.984-12.984H-16.172l5.578-5.625L-12-20.016-20.016-12-12-3.984l1.406-1.406-5.578-5.625H-3.984Z",
            transform: "translate(-3.984 -3.984) rotate(180)",
            fill: "#fff"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/localStorageFunctions.js
var localStorageFunctions = __webpack_require__(174943);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/validateEmailError.js
var validateEmailError = __webpack_require__(695288);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
;// CONCATENATED MODULE: ./src/components/DesignSystem/SubscriberInput/index.js










var SubscriberInput = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store,
            leadgenInfo: state.leadGenReducer.leadgenInfo,
            userData: state.userReducer.data
        };
    }), leadgenInfo = ref5.leadgenInfo, userData = ref5.userData, store = ref5.store;
    var ref6 = (0,react.useState)(""), sColor = ref6[0], setColor = ref6[1];
    var ref7 = (0,react.useState)(""), leadInput = ref7[0], setLeadInput = ref7[1];
    var ref8 = (0,react.useState)(false), leadError = ref8[0], setLeadError = ref8[1];
    var ref9 = (0,react.useState)(false), isSubmitInTransit = ref9[0], setIsSubmitInTransit = ref9[1];
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) {
            var ref2, ref3;
            setColor((store === null || store === void 0 ? void 0 : store.premium) ? store === null || store === void 0 ? void 0 : (ref2 = store.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#000000");
        }
    }, [
        store === null || store === void 0 ? void 0 : (ref = store.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
    ]);
    var handleLeadInput = function(e) {
        var ref;
        var value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE && value.length <= 10 || (leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL) setLeadInput(value);
    };
    var submitLeadInput = function() {
        setIsSubmitInTransit(true);
        var phoneReg = /(6|7|8|9)\d{9}/;
        var emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var payload = {
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            lead_user_phone: "",
            lead_email_id: "",
            user_phone: userData === null || userData === void 0 ? void 0 : userData.phone
        };
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE) payload["lead_user_phone"] = leadInput;
        else payload["lead_email_id"] = leadInput;
        if (payload["lead_email_id"]) {
            var status = (0,validateEmailError/* validateEmailError */.n)(payload["lead_email_id"]);
            if (!status) {
                return;
            }
        }
        var callback = function() {
            (0,Toast/* toastNotifySuccess */.jh)("Thanks for subscribing!");
            (0,localStorageFunctions/* setLeadData */.co)(leadInput);
            setLeadInput("");
            setTimeout(function() {
                return setIsSubmitInTransit(false);
            }, 500);
        };
        if ((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.PHONE */.hm.PHONE && leadInput.length === 10 && leadInput.match(phoneReg)) {
            dispatch((0,leadgen/* updateCustomerLead */.x6)(payload, callback));
        } else if (leadInput.match(emailReg)) dispatch((0,leadgen/* updateCustomerLead */.x6)(payload, callback));
        else setLeadError(true);
    };
    var renderError = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "error-msg flex f7 red flex justify-start items-center mt2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "ba b--red flex justify-center items-center br-pill bg-red white mr2 error-icon",
                    style: {
                        fontSize: 8,
                        padding: "2px 6px"
                    },
                    children: [
                        " ",
                        "!",
                        " "
                    ]
                }),
                "Please enter a valid ".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "email ID" : "phone number")
            ]
        });
    };
    return !!storePhone && (leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.status) && !(0,localStorageFunctions/* getLeadData */.X5)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "f6 mb2",
                children: "Subscribe for latest updates & offers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-start items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        placeholder: "Enter ".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "Email" : "Phone Number"),
                        value: leadInput,
                        className: "f6 bg-white pv2 ph2 b--black-10 w-100 rm-input-num-arrows",
                        onChange: handleLeadInput,
                        type: "".concat((leadgenInfo === null || leadgenInfo === void 0 ? void 0 : leadgenInfo.type) === constants/* LEAD_GENERATION_TYPES.EMAIL */.hm.EMAIL ? "email" : "number")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "bn pointer",
                        "aria-label": "Subscribe for latest offers",
                        style: {
                            backgroundColor: "".concat(sColor || (store === null || store === void 0 ? void 0 : (ref2 = store.store_info) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color)),
                            borderRadius: "0px 4px 4px 0px",
                            padding: "9px 12px 8px 12px"
                        },
                        onClick: submitLeadInput,
                        disabled: isSubmitInTransit,
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardArrow, {
                                color: "#0000000"
                            })
                        ]
                    })
                ]
            }),
            leadError ? renderError() : null
        ]
    }) : null;
};
/* harmony default export */ var DesignSystem_SubscriberInput = (SubscriberInput);


/***/ }),

/***/ 901218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _util_arePropsEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(548729);
/* harmony import */ var _utils_getGoogleMapUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(448863);




function FooterMap2(props) {
    var ref, ref1, ref2, ref3, ref4;
    var storeData = props.storeData, _height = props.height, height = _height === void 0 ? "250" : _height;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loadMap = ref5[0], setLoadMap = ref5[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return !!(storeData === null || storeData === void 0 ? void 0 : storeData.address) && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === 1 && !!(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.address) === null || ref1 === void 0 ? void 0 : ref1.latitude) && !!(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.address) === null || ref2 === void 0 ? void 0 : ref2.longitude) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Footer2__section",
        ref: containerRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            width: "100%",
            height: height,
            title: "Address",
            loading: "lazy",
            src: loadMap ? (0,_utils_getGoogleMapUrl__WEBPACK_IMPORTED_MODULE_2__/* .getGoogleMapUrl */ .D)(storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.address) === null || ref3 === void 0 ? void 0 : ref3.latitude, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.address) === null || ref4 === void 0 ? void 0 : ref4.longitude) : ""
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FooterMap2, _util_arePropsEqual__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z));


/***/ }),

/***/ 176364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sy": function() { return /* reexport */ FooterMap_FooterMap; },
  "oJ": function() { return /* reexport */ FooterMap2/* default */.Z; },
  "IA": function() { return /* reexport */ FooterMap_FooterMap3; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/FooterMap/util/arePropsEqual.js
var arePropsEqual = __webpack_require__(548729);
// EXTERNAL MODULE: ./src/utils/getGoogleMapUrl.js
var getGoogleMapUrl = __webpack_require__(448863);
;// CONCATENATED MODULE: ./src/components/FooterMap/FooterMap.js




var FooterMap = /*#__PURE__*/ react.memo(function FooterMap(props) {
    var ref, ref1, ref2, ref3, ref4;
    var storeData = props.storeData;
    var ref5 = (0,react.useState)(false), loadMap = ref5[0], setLoadMap = ref5[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    return !!(storeData === null || storeData === void 0 ? void 0 : storeData.address) && (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.address) === null || ref === void 0 ? void 0 : ref.visibility) === 1 && !!(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.address) === null || ref1 === void 0 ? void 0 : ref1.latitude) && !!(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.address) === null || ref2 === void 0 ? void 0 : ref2.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: containerRef,
        style: {
            display: "flex",
            height: "100%",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            width: "100%",
            height: "250",
            title: "Address",
            loading: "lazy",
            src: loadMap ? (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.address) === null || ref3 === void 0 ? void 0 : ref3.latitude, storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.address) === null || ref4 === void 0 ? void 0 : ref4.longitude) : ""
        })
    });
}, arePropsEqual/* default */.Z);
/* harmony default export */ var FooterMap_FooterMap = (FooterMap);

// EXTERNAL MODULE: ./src/components/FooterMap/FooterMap2.js
var FooterMap2 = __webpack_require__(901218);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/components/FooterMap/FooterMap3.js





function FooterMap3(props) {
    var _storeData = props.storeData, storeData = _storeData === void 0 ? {} : _storeData;
    var _address = storeData.address, address = _address === void 0 ? {} : _address;
    var ref = (0,react.useState)(false), loadMap = ref[0], setLoadMap = ref[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            if (entries[0].isIntersecting) {
                setLoadMap(true);
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return function() {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);
    var addressVisibilityHidden = function(visibilityValue) {
        return (address === null || address === void 0 ? void 0 : address.visibility) === visibilityValue;
    };
    var onHover = function() {
        document.getElementById("mapFrame").style.filter = "brightness(100%)";
        document.getElementById("mapText").style.display = "none";
    };
    var onHoverLeave = function() {
        document.getElementById("mapFrame").style.filter = "brightness(40%)";
        document.getElementById("mapText").style.display = "block";
    };
    return addressVisibilityHidden(constants/* ADDRESS_VISIBILITY.VISIBLE */.lE.VISIBLE) && !!address && !!(address === null || address === void 0 ? void 0 : address.latitude) && !!(address === null || address === void 0 ? void 0 : address.longitude) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: containerRef,
        className: "Footer3__map-section",
        onMouseEnter: onHover,
        onMouseLeave: onHoverLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                loading: "lazy",
                className: "map-frame",
                id: "mapFrame",
                width: "100%",
                height: "300px",
                title: "Address",
                src: loadMap ? (0,getGoogleMapUrl/* getGoogleMapUrl */.D)(address === null || address === void 0 ? void 0 : address.latitude, address === null || address === void 0 ? void 0 : address.longitude) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "map-text",
                id: "mapText",
                children: "Find us here"
            })
        ]
    });
}
/* harmony default export */ var FooterMap_FooterMap3 = (/*#__PURE__*/react.memo(FooterMap3, arePropsEqual/* default */.Z));

;// CONCATENATED MODULE: ./src/components/FooterMap/index.js





/***/ }),

/***/ 548729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ arePropsEqual; }
/* harmony export */ });
function arePropsEqual(prevProps, nextProps) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return ((ref = prevProps.storeData) === null || ref === void 0 ? void 0 : ref.address) === ((ref1 = nextProps.storeData) === null || ref1 === void 0 ? void 0 : ref1.address) && ((ref2 = prevProps.storeData) === null || ref2 === void 0 ? void 0 : ref2.latitude) === ((ref3 = nextProps.storeData) === null || ref3 === void 0 ? void 0 : ref3.latitude) && ((ref4 = prevProps.storeData) === null || ref4 === void 0 ? void 0 : ref4.longitude) === ((ref5 = nextProps.storeData) === null || ref5 === void 0 ? void 0 : ref5.longitude);
}


/***/ }),

/***/ 273323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268037);
/* harmony import */ var _utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273494);


/**
 * use this hook to get info about store logo and store name visibility in Header and Footer.
 * visibility is defined by merchant by using editor.
 */ var useStoreLogoOrNameVisibility = function() {
    var ref = (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store.theme || {};
    }), _store_logo_status = ref.store_logo_status, store_logo_status = _store_logo_status === void 0 ? false : _store_logo_status, _store_name_status = ref.store_name_status, store_name_status = _store_name_status === void 0 ? false : _store_name_status;
    return {
        isStoreLogoInHeader: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForHeader */ .g)(store_logo_status),
        isStoreLogoInFooter: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForFooter */ .S)(store_logo_status),
        isStoreNameInHeader: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForHeader */ .g)(store_name_status),
        isStoreNameInFooter: (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibilityForFooter */ .S)(store_name_status)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStoreLogoOrNameVisibility);


/***/ }),

/***/ 13605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ commonToggleAuthModal; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/**
 * common function to initiate auth toggle
 * @param {*} param0
 * @return {boolean} return
 */ var commonToggleAuthModal = function(param) {
    var userLogin = param.userLogin, storeInfoDomain = param.storeInfoDomain;
    if (userLogin) {
        return true;
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)(_routes__WEBPACK_IMPORTED_MODULE_0__.PATH.ORDERS, storeInfoDomain));
    }
    return false;
};


/***/ }),

/***/ 448863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getGoogleMapUrl; }
/* harmony export */ });
var getGoogleMapUrl = function(latitude, longitude) {
    return "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAVC1rp28LPP-kwCwVPZpZEt5LqLNYXVS8", "&q=").concat(latitude, ",").concat(longitude);
};


/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ }),

/***/ 695288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ validateEmailError; }
/* harmony export */ });
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40804);

function validateEmailError(mail) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(mail)) {
        (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_0__/* .toastNotifyError */ .Lu)("Invalid Email Id");
        return false;
    }
    return true;
}


/***/ }),

/***/ 186438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottom_section":"FooterStorePolicies_bottom_section__Q64j2","footer__bottom-text":"FooterStorePolicies_footer__bottom-text__Cfylc","policy-nav":"FooterStorePolicies_policy-nav__u8EJg","store_policies":"FooterStorePolicies_store_policies__hE_9r","footer_nav":"FooterStorePolicies_footer_nav__DLmtJ"};

/***/ })

}]);